import { useState } from "react";
import { Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

// Property photos — ≥1 required before publish (server-enforced at
// /commercial/properties/{id}/publish). Same object-storage upload pipeline as
// host listings; persisted via the existing property PATCH.
export default function PropertyPhotos({ prop, onChange }) {
  const [uploading, setUploading] = useState(false);
  const [uploadPct, setUploadPct] = useState(0);
  const images = prop.images || [];

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setUploading(true);
    setUploadPct(0);
    try {
      const urls = [...images];
      for (const f of files.slice(0, 10 - urls.length)) {
        const r = await api.uploadListingPhoto(f, setUploadPct);
        urls.push(r.url);
      }
      await api.commercialPropertyPatch(prop.property_id, { images: urls });
      onChange();
    } catch (err) { toast.error(err.message); } finally { setUploading(false); }
  };

  const remove = async (u) => {
    try {
      await api.commercialPropertyPatch(prop.property_id, { images: images.filter((x) => x !== u) });
      onChange();
    } catch (e) { toast.error(e.message); }
  };

  return (
    <div className="card-dark p-6" data-testid="property-photos">
      <p className="meta-label">Property photos</p>
      <p className="text-xs text-zinc-500 mt-1.5">At least one photo is required before the property can be published.</p>
      <div className="mt-4 flex flex-wrap gap-2.5">
        {images.map((u) => (
          <div key={u} className="relative w-20 h-20 rounded-lg overflow-hidden border border-[#27272A]">
            <img src={u} alt="Property" className="w-full h-full object-cover" />
            <button type="button" onClick={() => remove(u)} aria-label="Remove photo" data-testid="property-photo-remove"
                    className="absolute top-1 right-1 p-1 rounded-full bg-black/70 text-white"><X className="w-3 h-3" /></button>
          </div>
        ))}
        <label className="w-20 h-20 rounded-lg border border-dashed border-[#27272A] flex flex-col items-center justify-center text-xs text-zinc-500 cursor-pointer hover:border-[#E50914]/50 transition-colors" data-testid="property-photo-upload">
          {uploading ? (<><Loader2 className="w-4 h-4 animate-spin" /><span className="mt-1 text-[10px]" data-testid="upload-progress">{uploadPct}%</span></>) : "+ Photo"}
          <input type="file" accept="image/png,image/jpeg,image/webp,image/heic,image/heif,.heic,.heif" multiple className="hidden" onChange={upload} />
        </label>
      </div>
    </div>
  );
}
